import React, { useRef } from 'react';

/**
 * Magnetic wrapper — translates child slightly toward the cursor on hover.
 *
 * Usage:
 *   <Magnetic strength={20}><Button /></Magnetic>     // inline, hugs content
 *   <Magnetic block strength={8}><Button /></Magnetic> // block, stretches to parent width (use with w-full buttons)
 */
export function Magnetic({ children, strength = 18, className = '', block = false }) {
  const wrap = useRef(null);
  const inner = useRef(null);

  const onMove = (e) => {
    if (!wrap.current || !inner.current) return;
    const rect = wrap.current.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    inner.current.style.transform = `translate(${(x / rect.width) * strength}px, ${(y / rect.height) * strength}px)`;
  };

  const onLeave = () => {
    if (inner.current) inner.current.style.transform = 'translate(0px, 0px)';
  };

  const display = block ? 'block w-full' : 'inline-block';

  return (
    <span
      ref={wrap}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={display + ' ' + className}
    >
      <span
        ref={inner}
        className={display + ' will-change-transform transition-transform duration-200 ease-out'}
      >
        {children}
      </span>
    </span>
  );
}

export default Magnetic;
